import { Api } from '../providers/api';
import { Booking } from '../entities/booking';
import { Component, ViewChild } from '@angular/core';
import { Config } from '../entities/config';
import { DashboardPage } from '../pages/dashboard/dashboard';
import { Database } from '../providers/database';
import { IntroPage } from '../pages/intro/intro';
import { LoginPage } from '../pages/auth/login/login';
import { NavController, Platform } from 'ionic-angular';
import { Shared } from '../providers/shared';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { User } from '../entities/user';
import { ScreenOrientation } from '@ionic-native/screen-orientation';

@Component({
    templateUrl: 'app.html'
})
export class DerryBrothers {

    @ViewChild('nav') navCtrl: NavController;

    rootPage: any;

    constructor(
        private api: Api,
        private database: Database,
        private platform: Platform,
        private screenOrientation: ScreenOrientation,
        private shared: Shared,
        private splashScreen: SplashScreen,
        private statusBar: StatusBar,
    ) {
        platform.ready().then(() => {
            // Okay, so the platform is ready and our plugins are available.
            // Here you can do any higher level native things you might need.
            if (platform.is('cordova')) {
                this.statusBar.styleLightContent();
                this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.PORTRAIT);
            }
        });
    }

    ngAfterViewInit() {

        this.platform.ready().then(async () => {

            await this.database.init();

            if (await this.showIntro()) {
                this.rootPage = IntroPage;
                this.splashScreen.hide();
                return;
            }

            let user: User = await this.loggedInUser();
            if (user === undefined) {
                this.rootPage = LoginPage;
                this.splashScreen.hide();
                return;
            }

            // User is logged in. Fetch Bookings and show Dashboard Page.
            try {
                let bookings: Booking[] = await this.api.getMyBookings();
                this.navCtrl.setRoot(DashboardPage, {bookings: bookings}, {animate: true, direction: 'forward'});
            } catch (error) {
                if (error.status == 401) {
                    console.error('NOT LOGGED IN');
                    this.rootPage = LoginPage;
                }
            }
            this.splashScreen.hide();

        });

    }

    async showIntro(): Promise<boolean> {
        // Try to retrieve the intro flag.
        let showIntro: Config = await this.shared.getConfig('showIntro');

        if (showIntro === undefined)
            showIntro = await this.shared.setAndStore('showIntro', false);

        return !showIntro.value;
    }

    async loggedInUser(): Promise<User> {
        let apiToken: Config = await this.shared.getConfigAndSetShared('apiToken');
        let userConfig: Config = await this.shared.getConfig('user');

        if (apiToken === undefined || userConfig === undefined) return;

        try {
            let user: User = await this.api.getMyDetails();
            if (user === undefined) return;
            await this.shared.setAndStore('user', user);
            return user;
        } catch (e) {
            if (e.status === 401) {
                await this.shared.unsetAndRemove('apiToken');
                await this.shared.unsetAndRemove('user');
            }
        }
    }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts